import { useEffect, useRef } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Spinner } from '@crazyegginc/hatch';
import Honeybadger from '@honeybadger-io/js';

import { BillingPaymentInfo } from '../components/BillingPaymentInfo';
import { BillingCompanyInfo } from '../components/BillingCompanyInfo';
import { BillingHistory } from '../components/BillingHistory';

import { billingDetailsQuery } from '../queries';
import { countriesQuery } from '../../_global/queries';

// eslint-disable-next-line no-restricted-syntax
export default function AccountBilling() {
  const { data, error: billingDetailsError } = useQuery({ ...billingDetailsQuery(), useErrorBoundary: false });
  const { data: dataCountries, error: countriesError } = useQuery({ ...countriesQuery(), useErrorBoundary: false });
  const reportedMissingBillingDetails = useRef(false);

  useEffect(() => {
    if (!billingDetailsError && data && !data.billingDetails && !reportedMissingBillingDetails.current) {
      reportedMissingBillingDetails.current = true;

      Honeybadger.notify('Billing details missing from query response', {
        context: {
          currentPath: window.location.pathname,
          hasBillingDetailsResponse: Boolean(data),
          hasCountriesResponse: Boolean(dataCountries),
        },
      });
    }
  }, [billingDetailsError, data, dataCountries]);

  if (billingDetailsError || countriesError) {
    return (
      <div className="mt-16 flex w-full items-center justify-center">
        <div className="ml-2.5">Failed to load. Please try again later.</div>
      </div>
    );
  }

  if (!data || !dataCountries) {
    return (
      <div className="mt-16 flex w-full items-center justify-center">
        <Spinner />
        <div className="ml-2.5">Loading...</div>
      </div>
    );
  }

  if (!data.billingDetails) {
    return (
      <div className="mt-16 flex w-full items-center justify-center">
        <div className="ml-2.5">Failed to load. Please try again later.</div>
      </div>
    );
  }

  return (
    <div className="px-10">
      <BillingPaymentInfo data={data.billingDetails} countries={dataCountries.countries} />
      <BillingCompanyInfo data={data.billingDetails} countries={dataCountries.countries} />
      <BillingHistory />
    </div>
  );
}
